import moment from 'moment';
import { STATUS_ID } from './Step5';
import { LASTID } from './Step1';

const nameCondition = (condition) => {
    switch (condition) {
        case STATUS_ID.LOW:
            return 'ต่ำ';
        case STATUS_ID.MEDIUM:
            return 'พอสมควร';
        case STATUS_ID.HIGH:
            return 'สูง';
        case STATUS_ID.SMALL:
            return 'น้อย';
        case STATUS_ID.LERGE:
            return 'มาก';
        case STATUS_ID.AWAY:
            return 'หมดไป';
        case STATUS_ID.REDUCE:
            return 'ลดลง';
        case STATUS_ID.ACCEPTABLE:
            return 'ยอมรับได้';
        case STATUS_ID.APPROVE:
            return 'อนุมัติ';
        case STATUS_ID.NOT_APPROVE:
            return 'ไม่อนุมัติ';
        default:
            return '-';
        // code block
    }
};

const nameConditionRisk = (condition) => {
    switch (condition) {
        case STATUS_ID.LOW:
            return 'ต่ำ';
        case STATUS_ID.MEDIUM:
            return 'กลาง';
        case STATUS_ID.HIGH:
            return 'สูง';
        default:
            return '-';
        // code block
    }
};

export default function PreviewtoString(data, version) {
    return `
    <html>
    <head>
        <meta charset="UTF-8" />
        <title>Document</title>
        <script type="text/javascript" src="https://ajax.googleapis.com/ajax/libs/jquery/1.6.2/jquery.min.js"></script>
        <script src="https://cdnjs.cloudflare.com/ajax/libs/FileSaver.js/2.0.5/FileSaver.min.js"></script>
        <script src="https://evidenceprime.github.io/html-docx-js/build/html-docx.js"></script>
    </head>
    <body style="white-space: normal">
    <center>
        <h2>${data?.identification?.dpiaName}</h2>
        <p>
            เอกสารฉบับนี้อ้างอิงขั้นตอนการทำ DPIA จาก Thailand Data
            Protection Guidelines 3.0 ส่วนที่ E1 โดยมีทั้งหมด 8 ขั้นตอน
            ดังนี้
        </p>
    </center>
    <p>
        <b>ขั้นตอนที่ 1 : DPIA Identification</b>
        <br/>
        <b>บันทึกลักษณะที่จำเป็นต้องจัดทำ DPIA</b>
        <br/>
        <ul>
        ${data?.identification?.dpiaIdentificationList
            ?.map((item) =>
                LASTID.includes(item.mDpiaIdentificationId)
                    ? `<li>
        ${item?.dpiaIdentificationName}</br>เหตุผลที่ไม่จำเป็นต้องจัดทำ:<br/>
        ${data?.identification?.reason}
        </li>`
                    : `<li>${item?.dpiaIdentificationName}</li>`
            )
            .join(' ')}
        </ul>
    </p>

    <p>
        <b>ขั้นตอนที่ 2 : Description</b>
        <br />
        <b>2.1 สภาพของการประมวลผลข้อมูล (Nature)</b>
        <br />
                  ${
                      data?.description
                          ? data?.description.natureDescription === '' ||
                            data?.description.natureDescription === null
                              ? '-'
                              : data?.description.natureDescription?.length ===
                                0
                              ? '-'
                              : data?.description.natureDescription
                                    .map(
                                        (topic) => `
        <ul>
            <li>${topic?.topicName}</li>
            <p>${topic?.topicDescription}</p>
        </ul>
    `
                                    )
                                    .join('')
                          : ''
                  }
    </p>
    <p>
        <b>2.2 ขอบเขตของการประมวลผลข้อมูล (Scope)</b>
        <br />
                        ${
                            data?.description
                                ? data?.description.scopeDescription === '' ||
                                  data?.description.scopeDescription === null
                                    ? '-'
                                    : data?.description.scopeDescription
                                          ?.length === 0
                                    ? '-'
                                    : data?.description.scopeDescription
                                          .map(
                                              (topic) => `
        <ul>
            <li>${topic?.topicName}</li>
            <p>${topic?.topicDescription}</p>
        </ul>
    `
                                          )
                                          .join('')
                                : ''
                        }
    </p>
    <p>
        <b>2.3 บริบทของการประมวลผลข้อมูล (Context)</b>
        <br />
         ${
             data?.description
                 ? data?.description.contextDescription === '' ||
                   data?.description.contextDescription === null
                     ? '-'
                     : data?.description.contextDescription?.length === 0
                     ? '-'
                     : data?.description.contextDescription
                           .map(
                               (topic) => `
        <ul>
            <li>${topic?.topicName}</li>
            <p>${topic?.topicDescription}</p>
        </ul>
    `
                           )
                           .join('')
                 : ''
         }
    </p>
    <p>
        <b>2.4 วัตถุประสงค์ของการประมวลผลข้อมูล (Purpose)</b>
        <br />
             ${
                 data?.description
                     ? data?.description.purposeDescription === '' ||
                       data?.description.purposeDescription === null
                         ? '-'
                         : data?.description.purposeDescription?.length === 0
                         ? '-'
                         : data?.description.purposeDescription
                               .map(
                                   (topic) => `
        <ul>
            <li>${topic?.topicName}</li>
            <p>${topic?.topicDescription}</p>
        </ul>
    `
                               )
                               .join('')
                     : ''
             }
    </p>
    <p>
        <b>ขั้นตอนที่ 3 : Consultation</b>
        <br />
        <b>
            ระบุ เหตุผล, วิธีการ,
            และช่วงเวลาที่จะปรึกษาหารือและรับฟังความเห็น
        </b>
        <br />
        ${
            data?.consultation
                ? data?.consultation.consultation === '' ||
                  data?.consultation.consultation === null
                    ? '-'
                    : data?.consultation?.length === 0
                    ? '-'
                    : data?.consultation
                          .map(
                              (topic) => `
        <ul>
            <li>${topic?.topicName}</li>
            <p>${topic?.topicDescription}</p>
        </ul>
    `
                          )
                          .join('')
                : ''
        }
    </p>
    <p>
        <b>ขั้นตอนที่ 4 : Necessity and proportionality</b>
        <br />
        <b>ความจำเป็นและความได้สัดส่วนของการประมวลผลข้อมูล</b>
        <br />

                    ${
                        data?.necessaryProportionality
                            ? data?.necessaryProportionality
                                  .necessaryProportionality === '' ||
                              data?.necessaryProportionality
                                  .necessaryProportionality === null
                                ? '-'
                                : data?.necessaryProportionality?.length === 0
                                ? '-'
                                : data?.necessaryProportionality
                                      .map(
                                          (topic) => `
        <ul>
            <li>${topic?.topicName}</li>
            <p>${topic?.topicDescription}</p>
        </ul>
    `
                                      )
                                      .join('')
                            : ''
                    }
    </p>
    <p>
        <b>ขั้นตอนที่ 5 : Risk assessment</b>
        <br />
        <b>ประเมินความเสี่ยง</b>
        <br />
        ${
            data?.identification?.dpiaIdentificationList.find((item) =>
                LASTID.includes(item.mDpiaIdentificationId)
            )
                ? '-'
                : data?.riskAssessment?.dpiaRiskAssessmentList
                      ?.map(
                          (item) => `
            ${item.sequence}. ${item.risk}
            <br />
            ผลการประเมินความเสี่ยง
            <ul>
            <li>ความน่าจะเป็น (Likelihood) : ${nameCondition(
                item.likelihood
            )}</li>
            <li>ความร้ายแรง (Severity) : ${nameCondition(item.severity)}</li>
            <li>ผลการประเมินความเสี่ยง : ${nameConditionRisk(item.results)}</li>
            </ul>
            ผลกระทบจากการประมวลผลข้อมูล
            <br/>
            <ul>
            ${item.dpiaRiskAssessmentImpactList?.length === 0 ? '-' : ''}
            ${item.dpiaRiskAssessmentImpactList
                ?.map(
                    (data) =>
                        `<li>${data.dpiaRiskAssessmentImpactName || '-'}</li>`
                )
                .join(' ')}
            </ul>
            <br />
            `
                      )
                      .join(' ')
        }
    </p>
    <p>
        <b>ขั้นตอนที่ 6 : Mitigating measures</b>
        <br />
        <b>ประเมินมาตรการที่ใช้ลดความเสี่ยง</b>
        <br />
        ${data?.measures?.dpiaMitigatingMeasuresList?.length === 0 ? '-' : ''}
        ${data?.measures?.dpiaMitigatingMeasuresList
            ?.map(
                (item) => `
            ${item.sequence}. ${item.dpiaMitigatingMeasuresOrganizeName}
            <ul>
            <li>ผลต่อความเสี่ยง : ${nameCondition(item.effectOnRisk)}</li>
            <li>ความเสี่ยงที่เหลืออยู่ : ${nameConditionRisk(
                item.remainingRisk
            )}</li>
            <li>ผลการพิจารณา : ${nameCondition(item.considerationResult)}</li>
            <li>พิจารณาโดย : ${item.considerationBy || '-'}</li>
            </ul>
            <br />
            `
            )
            .join(' ')}
    </p>

    <p>
        <b>ขั้นตอนที่ 7 : Documentation and planning</b>
        <br />
        ชื่อโครงการ : ${data?.planning?.projectName || '-'}
        <br />
        วันที่ดำเนินการเริ่มต้น : ${
            data?.planning?.startDate
                ? moment(data?.planning?.startDate).format('DD/MM/YYYY')
                : '-'
        } 
        <br />
        วันที่ดำเนินการสิ้นสุด: ${
            data?.planning?.endDate
                ? moment(data?.planning?.endDate).format('DD/MM/YYYY')
                : '-'
        }
        <br />
        ผู้รับผิดชอบ : ${data?.planning?.projectOwner || '-'}
        <br />
        ความเสี่ยงที่เหลืออยู่ : ${data?.planning?.dpiaRemainingRisk || '-'}
        <br />
        ความเห็นของ DPO : 
        ${
            data?.planning?.opinionDpo === true
                ? 'เห็นด้วย'
                : data?.planning?.opinionDpo === false
                ? 'ไม่เห็นด้วย เพราะ'
                : ''
        }
        ${
            data?.planning?.opinionDpo === false
                ? data?.planning?.dpoReason || '-'
                : data?.planning?.opinionDpo === true
                ? ''
                : '-'
        }
        <br />
        ผลจากการปรึกษาหารือและรับฟังความเห็น: 
        ${
            data?.planning?.opinionConsult === true
                ? 'เห็นด้วย'
                : data?.planning?.opinionConsult === false
                ? 'ไม่เห็นด้วย เพราะ'
                : ''
        }
        ${
            data?.planning?.opinionConsult === false
                ? data?.planning?.consultReason || '-'
                : data?.planning?.opinionConsult === true
                ? ''
                : '-'
        }
    </p>

    <p>
        <b>ขั้นตอนที่ 8 : Monitoring and review</b>
        <br />
        <b>บันทึกการติดตามตรวจสอบและทบทวน</b>
        <br />
        <ul>
            <li>ติดตามตรวจสอบโดย<br/>
            ${data?.monitoring?.followUpBy || '-'}
            </li>
            <li>
                การเผยแพร่เอกสาร DPIA ฉบับนี้<br/>
                ${data?.monitoring?.publicationOfDocument || '-'}
            </li>
        </ul>
    </p>

    <p>
        <b>งานที่เกี่ยวข้อง (Data Flow)</b>
        <br />
        <ul>
        ${data?.dataflowList
            ?.map((item) => `<li>${item.businessProcessName}</li>`)
            .join(' ')}
        </ul>
    </p>
    <script type="text/javascript">
    $(document).ready(function() {
    let allElements = $('*');
    let converted = htmlDocx.asBlob(allElements.html());
    saveAs(converted, '${data?.identification?.dpiaName}_${moment()
        .format('DD-MM-YYYY')
        .toString()}.docx');
        setTimeout(() => window.close(), 100)
    });
</script>
</body>
    </html>`;
}
